module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$l('archives/name')))]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.getSettingsAddons.noise == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('noise'),
    on: {
      "click": function($event) {
        return _vm.clicked('global')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Global')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.noise == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('noise'),
    on: {
      "click": function($event) {
        return _vm.clicked('noise')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Noise')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.noise == '1') ? _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        return _vm.clicked('audio')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Audio')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.video == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('video'),
    on: {
      "click": function($event) {
        return _vm.clicked('video')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Video')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.weather == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('weather'),
    on: {
      "click": function($event) {
        return _vm.clicked('weather')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Weather')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsAddons.adio == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('adio'),
    on: {
      "click": function($event) {
        return _vm.clicked('adio')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Adio')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "option",
    class: _vm.getClass('compressed'),
    on: {
      "click": function($event) {
        return _vm.clicked('compressed')
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('archives/popOver/Compressed')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-037a5518","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ArchivePopover.vue
// module id = 439
// module chunks = 1